package com.veldekar.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.AllSessionsContent
import com.veldekar.components.layouts.PageLayout
import com.veldekar.components.layouts.PageLayoutData
import com.veldekar.components.logs.Log_2023_01_14_Day_1
import com.veldekar.components.logs.Log_2023_01_14_Day_2
import com.veldekar.components.logs.Log_2023_01_20_Day_1
import com.veldekar.components.logs.Log_2023_01_20_Day_2
import com.veldekar.components.logs.Log_2023_01_27_Day_1
import com.veldekar.components.logs.Log_2023_01_27_Day_2
import com.veldekar.components.logs.Log_2023_02_17_Day_1
import com.veldekar.components.logs.Log_2023_03_03_Day_1
import com.veldekar.components.logs.Log_2023_03_03_Day_2
import com.veldekar.components.logs.Log_2023_03_10_Day_1
import com.veldekar.components.logs.Log_2023_03_10_Day_2
import com.veldekar.components.logs.Log_2023_03_17_Day_1
import com.veldekar.components.logs.Log_2023_03_24_Day_1
import com.veldekar.components.logs.Log_2023_03_24_Day_2
import com.veldekar.components.logs.Log_2023_03_24_Day_3
import com.veldekar.components.logs.Log_2023_03_31_Day_1
import com.veldekar.components.logs.Log_2023_03_31_Day_2
import com.veldekar.components.logs.Log_2023_03_31_Day_3
import com.veldekar.components.logs.Log_2023_04_14_Day_1
import com.veldekar.components.logs.Log_2023_05_12_Day_1
import com.veldekar.components.logs.Log_2023_05_12_Day_2
import com.veldekar.components.logs.Log_2023_05_19_Day_1
import com.veldekar.components.logs.Log_2023_05_19_Day_2
import com.veldekar.components.logs.Log_2023_05_19_Day_3
import com.veldekar.components.logs.Log_2023_05_26_Day_1
import com.veldekar.components.logs.Log_2023_06_02_Day_1
import com.veldekar.components.logs.Log_2023_06_02_Day_2
import com.veldekar.components.logs.Log_2023_06_09_Day_1
import com.veldekar.components.logs.Log_2023_06_16_Day_1
import com.veldekar.components.logs.Log_2023_06_16_Day_2
import com.veldekar.components.logs.Log_2023_06_23_Day_1
import com.veldekar.components.logs.Log_2023_06_30_Day_1
import com.veldekar.components.logs.Log_2023_06_30_Day_2
import com.veldekar.components.logs.Log_2023_07_14_Day_1
import com.veldekar.components.logs.Log_2023_07_21_Day_1
import com.veldekar.components.logs.Log_2023_07_28_Day_1
import com.veldekar.components.logs.Log_2023_08_04_Day_1
import com.veldekar.components.logs.Log_2023_08_11_Day_1
import com.veldekar.components.logs.Log_2023_08_18_Day_1
import com.veldekar.components.logs.Log_2023_08_18_Day_2
import com.veldekar.components.logs.Log_2023_08_18_Day_3
import com.veldekar.components.logs.Log_2023_08_18_Day_4
import com.veldekar.components.logs.Log_2023_08_18_Day_5
import com.veldekar.components.logs.Log_2023_08_25_Day_1
import com.veldekar.components.logs.Log_2023_08_25_Day_2
import com.veldekar.components.logs.Log_2023_09_01_Day_1
import com.veldekar.components.logs.Log_2023_11_19_Day_1
import com.veldekar.components.logs.Log_2023_12_08_Day_1
import com.veldekar.components.logs.Log_2023_12_08_Day_2
import com.veldekar.components.logs.Log_2023_12_15_Day_1
import com.veldekar.components.logs.Log_2023_12_22_Day_1
import com.veldekar.components.logs.Log_2023_12_22_Day_2
import com.veldekar.components.logs.Log_2024_01_26_Day_1
import com.veldekar.components.logs.Log_2024_02_02_Day_1
import com.veldekar.components.logs.Log_2024_02_02_Day_2
import com.veldekar.components.logs.Log_2024_02_02_Day_3
import com.veldekar.components.logs.Log_2024_02_02_Day_4
import com.veldekar.components.logs.Log_2024_02_02_Day_5
import com.veldekar.components.logs.Log_2024_02_23_Day_1
import com.veldekar.components.logs.Log_2024_03_01_Day_1
import com.veldekar.components.logs.Log_2024_03_01_Day_2
import com.veldekar.components.logs.Log_2024_03_08_Day_1
import com.veldekar.components.logs.Log_2024_03_15_Day_1
import com.veldekar.components.logs.Log_2024_03_15_Day_2
import com.veldekar.components.logs.Log_2024_04_05_Day_1
import com.veldekar.components.logs.Log_2024_04_12_Day_1
import com.veldekar.components.logs.Log_2024_04_12_Day_2
import com.veldekar.components.logs.Log_2024_04_12_Day_3
import com.veldekar.components.logs.Log_2024_04_12_Day_4
import com.veldekar.components.logs.Log_2024_04_19_Day_1
import com.veldekar.components.logs.Log_2024_04_26_Day_1
import com.veldekar.components.logs.Log_2024_05_03_Day_1
import com.veldekar.components.logs.Log_2024_05_03_Day_2
import com.veldekar.components.logs.Log_2024_05_10_Day_1
import com.veldekar.components.logs.Log_2024_05_17_Day_1
import com.veldekar.components.logs.Log_2024_05_24_Day_1
import com.veldekar.components.logs.Log_2024_07_05_Day_1
import com.veldekar.components.logs.Log_2024_09_27_Day_1
import com.veldekar.components.logs.Log_2024_09_27_Day_2
import com.veldekar.components.logs.Log_2024_09_27_Day_3
import com.veldekar.components.logs.Log_2024_09_27_Day_4
import com.veldekar.components.logs.Log_2024_10_11_Day_1
import com.veldekar.components.logs.Log_2024_10_11_Day_2
import com.veldekar.components.logs.Log_2024_10_11_Day_3
import com.veldekar.components.logs.Log_2024_12_07_Day_1
import com.veldekar.components.logs.Log_2024_12_07_Day_2
import com.veldekar.components.logs.Log_2024_12_07_Day_3
import com.veldekar.components.logs.Log_2024_12_07_Day_4
import com.veldekar.components.logs.Log_2024_12_28_Day_1
import com.veldekar.components.logs.Log_2024_12_28_Day_2
import com.veldekar.components.logs.Log_2024_12_28_Day_3
import com.veldekar.components.logs.Log_2025_01_04_Day_1
import com.veldekar.components.logs.Log_2025_01_04_Day_2
import com.veldekar.components.logs.Log_2025_01_04_Day_3
import com.veldekar.components.logs.Log_2025_01_11_Day_1
import com.veldekar.components.logs.Log_2025_01_11_Day_2
import com.veldekar.components.logs.Log_2025_01_11_Day_3
import com.veldekar.components.logs.Log_2025_01_18_Day_1
import com.veldekar.components.logs.Log_2025_01_18_Day_2
import com.veldekar.components.logs.Log_2025_01_25_Day_1
import com.veldekar.components.logs.Log_2025_02_01_Day_1
import com.veldekar.components.logs.Log_2025_02_08_Day_1
import com.veldekar.components.logs.Log_2025_02_15_Day_1
import com.veldekar.components.logs.Log_2025_02_22_Day_1
import com.veldekar.components.logs.Log_2025_02_22_Day_2
import com.veldekar.components.logs.Log_2025_02_22_Day_3
import com.veldekar.components.logs.Log_2025_03_01_Day_1
import com.veldekar.components.logs.Log_2025_03_01_Day_2
import com.veldekar.components.logs.Log_2025_03_15_Day_1
import com.veldekar.components.logs.Log_2025_03_15_Day_2
import com.veldekar.components.logs.Log_2025_03_22_Day_1
import com.veldekar.components.logs.Log_2025_03_22_Day_2
import com.veldekar.components.logs.Log_2025_03_22_Day_3
import com.veldekar.components.logs.Log_2025_03_22_Day_4
import com.veldekar.components.logs.Log_2025_03_22_Day_5
import com.veldekar.components.logs.Log_2025_03_29_Day_1
import com.veldekar.components.logs.Log_2025_03_29_Day_2
import com.veldekar.components.logs.Log_2025_03_29_Day_3
import com.veldekar.components.logs.Log_2025_04_05_Day_1
import com.veldekar.components.logs.Log_2025_04_05_Day_2
import com.veldekar.components.logs.Log_2025_04_05_Day_3
import com.veldekar.components.logs.Log_2025_04_12_Day_1
import com.veldekar.components.logs.Log_2025_04_12_Day_2
import com.veldekar.components.logs.Log_2025_04_12_Day_3
import com.veldekar.components.logs.Log_2025_04_19_Day_1
import com.veldekar.components.logs.Log_2025_04_19_Day_2
import com.veldekar.components.logs.Log_2025_04_26_Day_1
import com.veldekar.components.logs.Log_2025_04_26_Day_2
import com.veldekar.components.logs.Log_2025_04_26_Day_3
import com.veldekar.components.logs.Log_2025_04_26_Day_4
import com.veldekar.components.logs.Log_2025_05_03_Day_1
import com.veldekar.components.logs.Log_2025_05_10_Day_1
import com.veldekar.components.logs.Log_2025_05_17_Day_1
import com.veldekar.components.logs.Log_2025_05_24_Day_1
import com.veldekar.components.logs.Log_2025_05_24_Day_2
import com.veldekar.components.logs.Log_2025_11_08_Day_1
import com.veldekar.components.logs.Log_2025_11_15_Day_1
import com.veldekar.components.logs.Log_2025_11_15_Day_2
import com.veldekar.components.logs.Log_2025_11_22_Day_1
import com.veldekar.components.logs.Log_2025_11_29_Day_1
import com.veldekar.components.logs.Log_2025_11_29_Day_2
import com.veldekar.components.logs.Log_2025_12_06_Day_1
import com.veldekar.components.logs.Log_2025_12_13_Day_1
import com.veldekar.components.logs.Log_2026_01_03_Day_1
import com.veldekar.components.logs.Log_2026_01_10_Day_1
import com.veldekar.components.logs.Log_2026_01_10_Day_2
import com.veldekar.components.logs.Log_2026_02_07_Day_1
import com.veldekar.components.logs.Log_2026_02_14_Day_1
import com.veldekar.components.logs.Log_2026_02_14_Day_2
import com.veldekar.components.logs.Log_2026_02_14_Day_3
import com.veldekar.components.logs.Log_2026_02_21_Day_1
import com.veldekar.components.logs.Log_2026_03_07_Day_1
import com.veldekar.components.logs.Log_2026_03_07_Day_2
import com.veldekar.components.logs.Log_2026_03_07_Day_3
import com.veldekar.components.logs.Log_2026_03_14_Day_1
import com.veldekar.components.logs.Log_2026_03_14_Day_2
import com.veldekar.components.logs.Log_2026_03_14_Day_3
import com.veldekar.components.logs.Log_2026_03_14_Day_4
import com.veldekar.components.logs.Log_2026_03_14_Day_5
import com.veldekar.components.logs.Log_2026_03_21_Day_1
import com.veldekar.components.logs.Log_2026_03_21_Day_2
import com.veldekar.components.logs.Log_2026_03_21_Day_3
import com.veldekar.components.logs.Log_2026_03_28_Day_1
import com.veldekar.components.logs.Log_2026_04_11_Day_1
import com.veldekar.components.logs.Log_2026_04_11_Day_2
import com.veldekar.components.logs.Log_2026_04_11_Day_3
import com.veldekar.components.logs.Log_2026_04_18_Day_1
import com.veldekar.components.logs.Log_2026_04_18_Day_2
import com.veldekar.components.logs.Log_2026_04_18_Day_3
import com.veldekar.components.logs.Log_2026_04_18_Day_4
import com.veldekar.components.logs.Log_2026_05_02_Day_1
import com.veldekar.components.logs.Log_2026_05_02_Day_2
import com.veldekar.components.logs.Log_2026_05_02_Day_3
import com.veldekar.components.logs.Log_2026_05_09_Day_1
import com.veldekar.components.logs.Log_2026_05_23_Day_1
import com.veldekar.components.logs.Log_2026_05_30_Day_1
import com.veldekar.components.logs.Log_2026_05_30_Day_2
import com.veldekar.components.logs.Log_2026_06_06_Day_1
import com.veldekar.components.logs.Log_2026_08_01_Day_1
import com.veldekar.components.logs.Log_2026_08_01_Day_2
import com.veldekar.components.logs.Log_2026_08_08_Day_1
import com.veldekar.components.logs.Log_2026_08_08_Day_2
import com.veldekar.components.logs.Log_2026_08_29_Day_1
import com.veldekar.components.logs.Log_2026_08_29_Day_2
import com.veldekar.components.logs.Log_2026_08_29_Day_3
import com.veldekar.components.logs.Log_2026_08_29_Day_4
import com.veldekar.components.logs.Log_2026_09_12_Day_1
import com.veldekar.components.logs.Log_2026_09_12_Day_2
import com.veldekar.components.logs.Log_2026_09_12_Day_3
import com.veldekar.components.logs.Log_2026_09_12_Day_4
import com.veldekar.components.logs.Log_2026_10_10_Day_1
import com.veldekar.components.logs.Log_2026_10_10_Day_2
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page
@Composable
public fun Log(ctx: PageContext) {
    PageLayout(ctx, PageLayoutData(title = "Log", ogTitle = "Veldekar - Complete Session Log", ogDescription = "Complete chronological log of all D&D campaign sessions in the world of Veldekar.", ogImage = "ai/log_preview.webp", ogImageWidth = 1_200, ogImageHeight = 630, ogImageAlt = "A campaign chronicle book open on a tavern table with Tuesday Sunblossom counting coins")) {
        AllSessionsContent("Log") {
            LocalizedSessionDate(LocalDate(2_023, 1, 14))
            SessionDayHeader(dayId = "newgrowth-8", dateString = "Newgrowth 8")
            Log_2023_01_14_Day_1()
            SessionDayHeader(dayId = "newgrowth-9", dateString = "Newgrowth 9")
            Log_2023_01_14_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 1, 20))
            SessionDayHeader(dayId = "newgrowth-9", dateString = "Newgrowth 9")
            Log_2023_01_20_Day_1()
            SessionDayHeader(dayId = "newgrowth-10", dateString = "Newgrowth 10")
            Log_2023_01_20_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 1, 27))
            SessionDayHeader(dayId = "newgrowth-11", dateString = "Newgrowth 11")
            Log_2023_01_27_Day_1()
            SessionDayHeader(dayId = "newgrowth-12", dateString = "Newgrowth 12")
            Log_2023_01_27_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 2, 17))
            SessionDayHeader(dayId = "newgrowth-12", dateString = "Newgrowth 12")
            Log_2023_02_17_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 3, 3))
            SessionDayHeader(dayId = "newgrowth-16", dateString = "Newgrowth 16")
            Log_2023_03_03_Day_1()
            SessionDayHeader(dayId = "newgrowth-17", dateString = "Newgrowth 17")
            Log_2023_03_03_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 3, 10))
            SessionDayHeader(dayId = "newgrowth-17", dateString = "Newgrowth 17")
            Log_2023_03_10_Day_1()
            SessionDayHeader(dayId = "newgrowth-18", dateString = "Newgrowth 18")
            Log_2023_03_10_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 3, 17))
            SessionDayHeader(dayId = "newgrowth-18", dateString = "Newgrowth 18")
            Log_2023_03_17_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 3, 24))
            SessionDayHeader(dayId = "newgrowth-18", dateString = "Newgrowth 18")
            Log_2023_03_24_Day_1()
            SessionDayHeader(dayId = "newgrowth-19", dateString = "Newgrowth 19")
            Log_2023_03_24_Day_2()
            SessionDayHeader(dayId = "newgrowth-21", dateString = "Newgrowth 21")
            Log_2023_03_24_Day_3()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 3, 31))
            SessionDayHeader(dayId = "newgrowth-21", dateString = "Newgrowth 21")
            Log_2023_03_31_Day_1()
            SessionDayHeader(dayId = "newgrowth-22", dateString = "Newgrowth 22")
            Log_2023_03_31_Day_2()
            SessionDayHeader(dayId = "newgrowth-23", dateString = "Newgrowth 23")
            Log_2023_03_31_Day_3()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 4, 14))
            SessionDayHeader(dayId = "newgrowth-23", dateString = "Newgrowth 23")
            Log_2023_04_14_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 5, 12))
            SessionDayHeader(dayId = "newgrowth-24", dateString = "Newgrowth 24")
            Log_2023_05_12_Day_1()
            SessionDayHeader(dayId = "newgrowth-25", dateString = "Newgrowth 25")
            Log_2023_05_12_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 5, 19))
            SessionDayHeader(dayId = "newgrowth-26", dateString = "Newgrowth 26")
            Log_2023_05_19_Day_1()
            SessionDayHeader(dayId = "newgrowth-27", dateString = "Newgrowth 27")
            Log_2023_05_19_Day_2()
            SessionDayHeader(dayId = "newgrowth-28", dateString = "Newgrowth 28")
            Log_2023_05_19_Day_3()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 5, 26))
            SessionDayHeader(dayId = "newgrowth-28", dateString = "Newgrowth 28")
            Log_2023_05_26_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 6, 2))
            SessionDayHeader(dayId = "newgrowth-28", dateString = "Newgrowth 28")
            Log_2023_06_02_Day_1()
            SessionDayHeader(dayId = "newgrowth-29", dateString = "Newgrowth 29")
            Log_2023_06_02_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 6, 9))
            SessionDayHeader(dayId = "newgrowth-29", dateString = "Newgrowth 29")
            Log_2023_06_09_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 6, 16))
            SessionDayHeader(dayId = "newgrowth-29", dateString = "Newgrowth 29")
            Log_2023_06_16_Day_1()
            SessionDayHeader(dayId = "newgrowth-30", dateString = "Newgrowth 30")
            Log_2023_06_16_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 6, 23))
            SessionDayHeader(dayId = "newgrowth-30", dateString = "Newgrowth 30")
            Log_2023_06_23_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 6, 30))
            SessionDayHeader(dayId = "newgrowth-30", dateString = "Newgrowth 30")
            Log_2023_06_30_Day_1()
            SessionDayHeader(dayId = "newgrowth-31", dateString = "Newgrowth 31")
            Log_2023_06_30_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 7, 14))
            SessionDayHeader(dayId = "newgrowth-31", dateString = "Newgrowth 31")
            Log_2023_07_14_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 7, 21))
            SessionDayHeader(dayId = "newgrowth-31", dateString = "Newgrowth 31")
            Log_2023_07_21_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 7, 28))
            SessionDayHeader(dayId = "newgrowth-32", dateString = "Newgrowth 32")
            Log_2023_07_28_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 8, 4))
            SessionDayHeader(dayId = "newgrowth-32", dateString = "Newgrowth 32")
            Log_2023_08_04_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 8, 11))
            SessionDayHeader(dayId = "newgrowth-32", dateString = "Newgrowth 32")
            Log_2023_08_11_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 8, 18))
            SessionDayHeader(dayId = "newgrowth-32", dateString = "Newgrowth 32")
            Log_2023_08_18_Day_1()
            SessionDayHeader(dayId = "newgrowth-33", dateString = "Newgrowth 33")
            Log_2023_08_18_Day_2()
            SessionDayHeader(dayId = "newgrowth-34", dateString = "Newgrowth 34")
            Log_2023_08_18_Day_3()
            SessionDayHeader(dayId = "newgrowth-35", dateString = "Newgrowth 35")
            Log_2023_08_18_Day_4()
            SessionDayHeader(dayId = "newgrowth-36", dateString = "Newgrowth 36")
            Log_2023_08_18_Day_5()
            SessionMediaItem(
                image = "images/drill_10percent_optimized.gif",
                linkImage = "images/drill_30percent_optimized.gif",
                description = "An animated LEGO scene featuring numerous figures on a blue baseplate representing water. The scene shows the type of work that Annette Dazzlecraft used to do a defense contractor. Inspecting cannons and siege weapons.",
                width = 302,
                height = 358,
            )
            SessionMediaItem(
                image = "images/farmTool_10percent_optimized.gif",
                linkImage = "images/farmTool_30percent_optimized.gif",
                description = "A high-quality animated LEGO farm scene with plants and figures. This is a depiction of an agricultural machine manufactured by Dazzlecraft and Tinkerrock.",
                width = 302,
                height = 243,
            )
            SessionMediaItem(
                image = "images/workshopHappy_10percent_optimized.gif",
                linkImage = "images/workshopHappy_30percent_optimized.gif",
                description = "A higher quality animated LEGO scene of a happy, busy workshop. This is Dazzlecraft and Tinkerrock's workshop before Tinkerrock was lynched by a mob.",
                width = 302,
                height = 246,
            )
            SessionMediaItem(
                image = "images/workshopSad_10percent_optimized.gif",
                linkImage = "images/workshopSad_30percent_optimized.gif",
                description = "A higher quality animated LEGO scene of the workshop taken over by spooky figures. This is Dazzlecraft and Tinkerrock's workshop; depicting a mob lynching Tinkerrock.",
                width = 302,
                height = 233,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 8, 25))
            SessionDayHeader(dayId = "newgrowth-36", dateString = "Newgrowth 36")
            Log_2023_08_25_Day_1()
            SessionDayHeader(dayId = "newgrowth-37", dateString = "Newgrowth 37")
            Log_2023_08_25_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 9, 1))
            SessionDayHeader(dayId = "newgrowth-37", dateString = "Newgrowth 37")
            Log_2023_09_01_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 11, 19))
            SessionDayHeader(dayId = "newgrowth-37", dateString = "Newgrowth 37")
            Log_2023_11_19_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 12, 8))
            SessionDayHeader(dayId = "newgrowth-38", dateString = "Newgrowth 38")
            Log_2023_12_08_Day_1()
            SessionDayHeader(dayId = "newgrowth-39", dateString = "Newgrowth 39")
            Log_2023_12_08_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 12, 15))
            SessionDayHeader(dayId = "newgrowth-39", dateString = "Newgrowth 39")
            Log_2023_12_15_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_023, 12, 22))
            SessionDayHeader(dayId = "newgrowth-39", dateString = "Newgrowth 39")
            Log_2023_12_22_Day_1()
            SessionDayHeader(dayId = "newgrowth-40", dateString = "Newgrowth 40")
            Log_2023_12_22_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 1, 26))
            SessionDayHeader(dayId = "newgrowth-40", dateString = "Newgrowth 40")
            Log_2024_01_26_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 2, 2))
            SessionDayHeader(dayId = "newgrowth-41", dateString = "Newgrowth 41")
            Log_2024_02_02_Day_1()
            SessionDayHeader(dayId = "newgrowth-42", dateString = "Newgrowth 42")
            Log_2024_02_02_Day_2()
            SessionDayHeader(dayId = "newgrowth-43", dateString = "Newgrowth 43")
            Log_2024_02_02_Day_3()
            SessionDayHeader(dayId = "newgrowth-44", dateString = "Newgrowth 44")
            Log_2024_02_02_Day_4()
            SessionDayHeader(dayId = "newgrowth-45", dateString = "Newgrowth 45")
            Log_2024_02_02_Day_5()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 2, 23))
            SessionDayHeader(dayId = "newgrowth-45", dateString = "Newgrowth 45")
            Log_2024_02_23_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 3, 1))
            SessionDayHeader(dayId = "newgrowth-45", dateString = "Newgrowth 45")
            Log_2024_03_01_Day_1()
            SessionDayHeader(dayId = "newgrowth-46", dateString = "Newgrowth 46")
            Log_2024_03_01_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 3, 8))
            SessionDayHeader(dayId = "newgrowth-46", dateString = "Newgrowth 46")
            Log_2024_03_08_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 3, 15))
            SessionDayHeader(dayId = "newgrowth-46", dateString = "Newgrowth 46")
            Log_2024_03_15_Day_1()
            SessionDayHeader(dayId = "newgrowth-47", dateString = "Newgrowth 47")
            Log_2024_03_15_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 4, 5))
            SessionDayHeader(dayId = "newgrowth-47", dateString = "Newgrowth 47")
            Log_2024_04_05_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 4, 12))
            SessionDayHeader(dayId = "newgrowth-47", dateString = "Newgrowth 47")
            Log_2024_04_12_Day_1()
            SessionDayHeader(dayId = "newgrowth-49", dateString = "Newgrowth 49")
            Log_2024_04_12_Day_2()
            SessionDayHeader(dayId = "newgrowth-50", dateString = "Newgrowth 50")
            Log_2024_04_12_Day_3()
            SessionDayHeader(dayId = "newgrowth-51", dateString = "Newgrowth 51")
            Log_2024_04_12_Day_4()
            SessionMediaItem(
                image = "images/Footseller_Note.webp",
                linkImage = "images/Footseller_Note.webp",
                invertForDarkMode = true,
                ocrText = "Newgrowth 31, 2401 Master Footseller, This contract is of immediate and utmost importance. A sum of 10,000 gp shall be placed in your name upon successful proven completion of its terms, and as such the death of Annette Dazzlecraft must be pursued with alacrity. With authority, the MonCon",
                description = "Evidence of a contract to kill Annette Dazzlecraft.",
                width = 1_538,
                height = 2_230,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 4, 19))
            SessionDayHeader(dayId = "newgrowth-51", dateString = "Newgrowth 51")
            Log_2024_04_19_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 4, 26))
            SessionDayHeader(dayId = "newgrowth-51", dateString = "Newgrowth 51")
            Log_2024_04_26_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 5, 3))
            SessionDayHeader(dayId = "newgrowth-51", dateString = "Newgrowth 51")
            Log_2024_05_03_Day_1()
            SessionDayHeader(dayId = "newgrowth-52", dateString = "Newgrowth 52")
            Log_2024_05_03_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 5, 10))
            SessionDayHeader(dayId = "newgrowth-52", dateString = "Newgrowth 52")
            Log_2024_05_10_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 5, 17))
            SessionDayHeader(dayId = "newgrowth-52", dateString = "Newgrowth 52")
            Log_2024_05_17_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 5, 24))
            SessionDayHeader(dayId = "newgrowth-52", dateString = "Newgrowth 52")
            Log_2024_05_24_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 7, 5))
            SessionDayHeader(dayId = "newgrowth-53", dateString = "Newgrowth 53")
            Log_2024_07_05_Day_1()
            SessionMediaItem(
                image = "images/RemainingShards_small.webp",
                linkImage = "images/RemainingShards.webp",
                description = "A hand-drawn map of Veldekar with pink numbers 1-7 identifying the remaining shards of the Shield of Concar as scried by the Heroes.",
                width = 1_080,
                height = 805,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 9, 27))
            SessionDayHeader(dayId = "newgrowth-53", dateString = "Newgrowth 53")
            Log_2024_09_27_Day_1()
            SessionDayHeader(dayId = "newgrowth-55", dateString = "Newgrowth 55")
            Log_2024_09_27_Day_2()
            SessionDayHeader(dayId = "newgrowth-56", dateString = "Newgrowth 56")
            Log_2024_09_27_Day_3()
            SessionDayHeader(dayId = "newgrowth-57", dateString = "Newgrowth 57")
            Log_2024_09_27_Day_4()
            SessionMediaItem(
                image = "images/LadyAventary_ElrovirRodiridan_small.webp",
                linkImage = "images/LadyAventary_ElrovirRodiridan.webp",
                description = "A hand-drawn map of Veldekar with pink annotations for significant locations in the relationship between Lady Aventary and Elrovir Rodiridan.",
                width = 1_080,
                height = 801,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 10, 11))
            SessionDayHeader(dayId = "newgrowth-57", dateString = "Newgrowth 57")
            Log_2024_10_11_Day_1()
            SessionDayHeader(dayId = "newgrowth-58", dateString = "Newgrowth 58", cardImageSrc = "images/MalusToBrijBridge.webp", width = 876, height = 574)
            Log_2024_10_11_Day_2()
            SessionDayHeader(dayId = "newgrowth-63", dateString = "Newgrowth 63")
            Log_2024_10_11_Day_3()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 12, 7))
            SessionDayHeader(dayId = "newgrowth-63", dateString = "Newgrowth 63", cardImageSrc = "images/lobsterBibCat.webp", width = 2_467, height = 3_209)
            Log_2024_12_07_Day_1()
            SessionDayHeader(dayId = "newgrowth-64", dateString = "Newgrowth 64")
            Log_2024_12_07_Day_2()
            SessionDayHeader(dayId = "newgrowth-65", dateString = "Newgrowth 65")
            Log_2024_12_07_Day_3()
            SessionDayHeader(dayId = "newgrowth-66", dateString = "Newgrowth 66")
            Log_2024_12_07_Day_4()
            SessionMediaItem(
                image = "images/coveredWagon_small.webp",
                linkImage = "images/coveredWagon.webp",
                description = "A hand-drawn illustration of Joral Deetry's covered wagon on a sandy ground under a bright sun.",
                width = 1_878,
                height = 1_542,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_024, 12, 28))
            SessionDayHeader(dayId = "newgrowth-67", dateString = "Newgrowth 67")
            Log_2024_12_28_Day_1()
            SessionDayHeader(dayId = "newgrowth-68", dateString = "Newgrowth 68")
            Log_2024_12_28_Day_2()
            SessionDayHeader(dayId = "newgrowth-69", dateString = "Newgrowth 69")
            Log_2024_12_28_Day_3()
            SessionMediaItem(
                image = "images/bigglesworthFallsInBattle.gif",
                linkImage = "images/bigglesworthFallsInBattle.gif",
                description = "An animated GIF showing a LEGO scorpion-like creature killing a LEGO monkey (representing Bigglesworth).",
                width = 1_210,
                height = 907,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 1, 4))
            SessionDayHeader(dayId = "newgrowth-69", dateString = "Newgrowth 69")
            Log_2025_01_04_Day_1()
            SessionDayHeader(dayId = "newgrowth-70", dateString = "Newgrowth 70")
            Log_2025_01_04_Day_2()
            SessionDayHeader(dayId = "newgrowth-71", dateString = "Newgrowth 71")
            Log_2025_01_04_Day_3()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 1, 11))
            SessionDayHeader(dayId = "newgrowth-71", dateString = "Newgrowth 71")
            Log_2025_01_11_Day_1()
            SessionDayHeader(dayId = "newgrowth-72", dateString = "Newgrowth 72")
            Log_2025_01_11_Day_2()
            SessionDayHeader(dayId = "newgrowth-73", dateString = "Newgrowth 73")
            Log_2025_01_11_Day_3()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 1, 18))
            SessionDayHeader(dayId = "newgrowth-73", dateString = "Newgrowth 73")
            Log_2025_01_18_Day_1()
            SessionDayHeader(dayId = "newgrowth-74", dateString = "Newgrowth 74")
            Log_2025_01_18_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 1, 25))
            SessionDayHeader(dayId = "newgrowth-74", dateString = "Newgrowth 74")
            Log_2025_01_25_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 2, 1))
            SessionDayHeader(dayId = "newgrowth-74", dateString = "Newgrowth 74")
            Log_2025_02_01_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 2, 8))
            SessionDayHeader(dayId = "newgrowth-74", dateString = "Newgrowth 74")
            Log_2025_02_08_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 2, 15))
            SessionDayHeader(dayId = "newgrowth-74", dateString = "Newgrowth 74")
            Log_2025_02_15_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 2, 22))
            SessionDayHeader(dayId = "newgrowth-75", dateString = "Newgrowth 75")
            Log_2025_02_22_Day_1()
            SessionDayHeader(dayId = "newgrowth-76", dateString = "Newgrowth 76")
            Log_2025_02_22_Day_2()
            SessionDayHeader(dayId = "newgrowth-77", dateString = "Newgrowth 77")
            Log_2025_02_22_Day_3()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 3, 1))
            SessionDayHeader(dayId = "newgrowth-77", dateString = "Newgrowth 77")
            Log_2025_03_01_Day_1()
            SessionDayHeader(dayId = "newgrowth-78", dateString = "Newgrowth 78")
            Log_2025_03_01_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 3, 15))
            SessionDayHeader(dayId = "newgrowth-78", dateString = "Newgrowth 78")
            Log_2025_03_15_Day_1()
            SessionDayHeader(dayId = "newgrowth-79", dateString = "Newgrowth 79")
            Log_2025_03_15_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 3, 22))
            SessionDayHeader(dayId = "newgrowth-79", dateString = "Newgrowth 79")
            Log_2025_03_22_Day_1()
            SessionDayHeader(dayId = "newgrowth-80", dateString = "Newgrowth 80")
            Log_2025_03_22_Day_2()
            SessionDayHeader(dayId = "newgrowth-81", dateString = "Newgrowth 81")
            Log_2025_03_22_Day_3()
            SessionDayHeader(dayId = "newgrowth-82", dateString = "Newgrowth 82")
            Log_2025_03_22_Day_4()
            SessionDayHeader(dayId = "newgrowth-83", dateString = "Newgrowth 83")
            Log_2025_03_22_Day_5()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 3, 29))
            SessionDayHeader(dayId = "newgrowth-83", dateString = "Newgrowth 83")
            Log_2025_03_29_Day_1()
            SessionDayHeader(dayId = "newgrowth-84", dateString = "Newgrowth 84")
            Log_2025_03_29_Day_2()
            SessionDayHeader(dayId = "newgrowth-85", dateString = "Newgrowth 85")
            Log_2025_03_29_Day_3()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 4, 5))
            SessionDayHeader(dayId = "newgrowth-85", dateString = "Newgrowth 85")
            Log_2025_04_05_Day_1()
            SessionDayHeader(dayId = "newgrowth-86", dateString = "Newgrowth 86")
            Log_2025_04_05_Day_2()
            SessionDayHeader(dayId = "newgrowth-87", dateString = "Newgrowth 87")
            Log_2025_04_05_Day_3()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 4, 12))
            SessionDayHeader(dayId = "newgrowth-87", dateString = "Newgrowth 87")
            Log_2025_04_12_Day_1()
            SessionDayHeader(dayId = "newgrowth-88", dateString = "Newgrowth 88")
            Log_2025_04_12_Day_2()
            SessionDayHeader(dayId = "newgrowth-89", dateString = "Newgrowth 89")
            Log_2025_04_12_Day_3()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 4, 19))
            SessionDayHeader(dayId = "newgrowth-90", dateString = "Newgrowth 90")
            Log_2025_04_19_Day_1()
            SessionDayHeader(dayId = "shimmer-1", dateString = "Shimmer 1")
            Log_2025_04_19_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 4, 26))
            SessionDayHeader(dayId = "shimmer-1", dateString = "Shimmer 1")
            Log_2025_04_26_Day_1()
            SessionDayHeader(dayId = "shimmer-2", dateString = "Shimmer 2")
            Log_2025_04_26_Day_2()
            SessionDayHeader(dayId = "shimmer-3", dateString = "Shimmer 3")
            Log_2025_04_26_Day_3()
            SessionDayHeader(dayId = "shimmer-4", dateString = "Shimmer 4")
            Log_2025_04_26_Day_4()
            SessionMediaItem(
                image = "images/pentishInDorvidianEmpire.webp",
                linkImage = "images/pentishInDorvidianEmpire.webp",
                description = "A hand-drawn map snippet on grid paper showing the Dorvidian Empire and the city of Pentish -- the home of Lord Pent, a powerful adversary of the heroes.",
                width = 960,
                height = 540,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 5, 3))
            SessionDayHeader(dayId = "shimmer-5", dateString = "Shimmer 5")
            Log_2025_05_03_Day_1()
            SessionMediaItem(
                video = "videos/decade.mp4",
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 5, 10))
            SessionDayHeader(dayId = "shimmer-5", dateString = "Shimmer 5")
            Log_2025_05_10_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 5, 17))
            SessionDayHeader(dayId = "shimmer-5", dateString = "Shimmer 5")
            Log_2025_05_17_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 5, 24))
            SessionDayHeader(dayId = "shimmer-5", dateString = "Shimmer 5")
            Log_2025_05_24_Day_1()
            SessionDayHeader(dayId = "shimmer-6", dateString = "Shimmer 6")
            Log_2025_05_24_Day_2()
            SessionMediaItem(
                image = "images/tooMuchGold.webp",
                linkImage = "images/tooMuchGold.webp",
                description = "A hand-drawn illustration of Dirk (left) and Annette (right) whose pockets are literally overflowing with cash and gold.",
                width = 2_653,
                height = 2_133,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 11, 8))
            SessionDayHeader(dayId = "shimmer-6", dateString = "Shimmer 6")
            Log_2025_11_08_Day_1()
            SessionMediaItem(
                image = "images/chickenFeet.webp",
                linkImage = "images/chickenFeet.webp",
                description = "A hand-drawn illustration showing a cat-character (representing Bigglesworth) sitting at a table and eating a bowl of noodles. A chicken foot is sticking out of the bowl.",
                width = 1_626,
                height = 2_691,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 11, 15))
            SessionDayHeader(dayId = "shimmer-6", dateString = "Shimmer 6")
            Log_2025_11_15_Day_1()
            SessionDayHeader(dayId = "shimmer-7", dateString = "Shimmer 7")
            Log_2025_11_15_Day_2()
            SessionMediaItem(
                image = "images/brightBrothers.webp",
                linkImage = "images/brightBrothers.webp",
                description = "A hand-drawn illustration featuring three 'bright' characters: a candle-man, a lightbulb-fox, and a flame-man. This is a meme reference to the Bright Brothers which Lord Fox was a member of.",
                width = 3_435,
                height = 2_734,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 11, 22))
            SessionDayHeader(dayId = "shimmer-8", dateString = "Shimmer 8", cardImageSrc = "images/crestOfThradorisFoxCrop.svg")
            Log_2025_11_22_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 11, 29))
            SessionDayHeader(dayId = "shimmer-8", dateString = "Shimmer 8")
            Log_2025_11_29_Day_1()
            SessionDayHeader(dayId = "shimmer-9", dateString = "Shimmer 9", cardImageSrc = "images/caperAndFoxMarionette_preview.webp", width = 1_200, height = 630)
            Log_2025_11_29_Day_2()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 12, 6))
            SessionDayHeader(dayId = "shimmer-9", dateString = "Shimmer 9")
            Log_2025_12_06_Day_1()
            SessionMediaItem(
                image = "images/footsmellerCoatOfArms_plain.svg",
                linkImage = "images/footsmellerCoatOfArms_plain.svg",
                description = "A vector graphic of a coat of arms featuring a face profile and a bare foot with green wavy 'smell' lines. This is a meme reference to the character Matty Footseller, who Tuesday referred to as a Footsmeller.",
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_025, 12, 13))
            SessionDayHeader(dayId = "shimmer-9", dateString = "Shimmer 9")
            Log_2025_12_13_Day_1()
            SessionMediaItem(
                image = "images/quokkaInHandcuffs_transparent.webp",
                linkImage = "images/quokkaInHandcuffs_transparent.webp",
                description = "A hand-drawn illustration of a quokka wearing blue handcuffs. This is Ludwig Voss after Tuesday used Polymorph to turn him into a quokka and turned him over to the Barrowmen.",
                width = 816,
                height = 1_080,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 1, 3))
            SessionDayHeader(dayId = "shimmer-9", dateString = "Shimmer 9")
            Log_2026_01_03_Day_1()
            SessionMediaItem(
                image = "images/gotAnyGrapes.webp",
                linkImage = "images/gotAnyGrapes.webp",
                description = "A cartoon illustration showing a fairy (Tuesday) talking to a muscular man at a lemonade stand. This is a reference to the meme \"Duck Song\"",
                width = 1_200,
                height = 630,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 1, 10))
            SessionDayHeader(dayId = "shimmer-9", dateString = "Shimmer 9")
            Log_2026_01_10_Day_1()
            SessionDayHeader(dayId = "shimmer-10", dateString = "Shimmer 10")
            Log_2026_01_10_Day_2()
            SessionMediaItem(
                image = "images/freeburgBastion.webp",
                linkImage = "images/freeburgBastion.webp",
                description = "A hand-drawn illustration of the Friends of the Forest's Freeburg Bastion with its yellow tower and surrounding wall.",
                width = 3_671,
                height = 2_860,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 2, 7))
            SessionDayHeader(dayId = "shimmer-10", dateString = "Shimmer 10")
            Log_2026_02_07_Day_1()
            SessionMediaItem(
                image = "images/lordFoxSeniorFamilyPortrait.webp",
                linkImage = "images/lordFoxSeniorFamilyPortrait.webp",
                description = "A hand-drawn family portrait of a regal man and two elegantly dressed women. The heroes found this drawing in the attic of Lord Fox's family estate, and it is meant to represent an elder Lord Fox's sister wives.",
                width = 4_032,
                height = 3_024,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 2, 14))
            SessionDayHeader(dayId = "shimmer-10", dateString = "Shimmer 10")
            Log_2026_02_14_Day_1()
            SessionDayHeader(dayId = "shimmer-11", dateString = "Shimmer 11")
            Log_2026_02_14_Day_2()
            SessionDayHeader(dayId = "shimmer-12", dateString = "Shimmer 12")
            Log_2026_02_14_Day_3()
            SessionMediaItem(
                image = "images/bigglesworthCatchesFish.gif",
                linkImage = "images/bigglesworthCatchesFish.gif",
                description = "An animated LEGO scene showing a cat-like character (representing Bigglesworth) interacting with a LEGO ship and catching a fish.",
                width = 1_210,
                height = 907,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 2, 21))
            SessionDayHeader(dayId = "shimmer-13", dateString = "Shimmer 13")
            Log_2026_02_21_Day_1()
            SessionMediaItem(
                image = "images/sailfishSurprise.webp",
                linkImage = "images/sailfishSurprise.webp",
                description = "A hand-drawn illustration of a sailfish, a sailboat, and a winged demon creature on the sea.",
                width = 4_032,
                height = 3_024,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 3, 7))
            SessionDayHeader(dayId = "shimmer-13", dateString = "Shimmer 13")
            Log_2026_03_07_Day_1()
            SessionDayHeader(dayId = "shimmer-14", dateString = "Shimmer 14")
            Log_2026_03_07_Day_2()
            SessionDayHeader(dayId = "shimmer-15", dateString = "Shimmer 15")
            Log_2026_03_07_Day_3()
            SessionMediaItem(
                image = "images/umbraxusMop.webp",
                linkImage = "images/umbraxusMop.webp",
                description = "A hand-drawn illustration of a green dragon wearing overalls and mopping a floor next to a caution sign. This is a reference to the name \"Umbraxus,\" which was supposed to strike fear into the hearts of the heroes but sounded more like an industrial cleaning product.",
                width = 3_995,
                height = 2_900,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 3, 14))
            SessionDayHeader(dayId = "shimmer-15", dateString = "Shimmer 15")
            Log_2026_03_14_Day_1()
            SessionDayHeader(dayId = "shimmer-16", dateString = "Shimmer 16")
            Log_2026_03_14_Day_2()
            SessionDayHeader(dayId = "shimmer-17", dateString = "Shimmer 17")
            Log_2026_03_14_Day_3()
            SessionDayHeader(dayId = "shimmer-18", dateString = "Shimmer 18")
            Log_2026_03_14_Day_4()
            SessionDayHeader(dayId = "shimmer-20", dateString = "Shimmer 20")
            Log_2026_03_14_Day_5()
            SessionMediaItem(
                image = "images/kostiganIsPie.webp",
                linkImage = "images/kostiganIsPie.webp",
                description = "A hand-drawn illustration of an island shaped like a large lattice-top pie.",
                width = 3_967,
                height = 2_783,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 3, 21))
            SessionDayHeader(dayId = "shimmer-20", dateString = "Shimmer 20")
            Log_2026_03_21_Day_1()
            SessionDayHeader(dayId = "shimmer-21", dateString = "Shimmer 21")
            Log_2026_03_21_Day_2()
            SessionDayHeader(dayId = "shimmer-22", dateString = "Shimmer 22")
            Log_2026_03_21_Day_3()
            SessionMediaItem(
                image = "images/highridgeIntruder.webp",
                linkImage = "images/highridgeIntruder.webp",
                description = "A hand-drawn map of Highridge (with a demon superimposed on top of it) and Kostigan next to an illustration of an angry man with a red bandana. This is a reference to the \"bed intruder\" meme.",
                width = 1_200,
                height = 630,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 3, 28))
            SessionDayHeader(dayId = "shimmer-22", dateString = "Shimmer 22", cardImageSrc = "images/saturdayNightCleaver.webp", width = 1_200, height = 630)
            Log_2026_03_28_Day_1()
            SessionMediaItem(
                image = "images/dancingEttin.webp",
                linkImage = "images/dancingEttin.webp",
                description = "A hand-drawn illustration of a two-headed giant (Ettin) wearing furs and a skull-decorated belt, holding a large blue cleaver. This is a meme reference to Saturday Night Fever. The mushroom cloud on the left is a reference to all the fireballs the heroes have been throwing at the giants and Ettins.",
                width = 1_424,
                height = 1_773,
            )
            SessionMediaItem(
                image = "images/mushroomCloud.webp",
                linkImage = "images/mushroomCloud.webp",
                description = "A hand-drawn illustration of a large mushroom cloud in shades of yellow, orange, and red caused by the D&D 5e spell \"Fireball.\"",
                width = 1_315,
                height = 1_068,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 4, 11))
            SessionDayHeader(dayId = "shimmer-22", dateString = "Shimmer 22", cardImageSrc = "images/cardiganOfDefenseSocial.webp", width = 1_195, height = 629)
            Log_2026_04_11_Day_1()
            SessionDayHeader(dayId = "shimmer-23", dateString = "Shimmer 23")
            Log_2026_04_11_Day_2()
            SessionDayHeader(dayId = "shimmer-25", dateString = "Shimmer 25")
            Log_2026_04_11_Day_3()
            SessionMediaItem(
                image = "images/cardiganOfDefense.webp",
                linkImage = "images/cardiganOfDefense.webp",
                description = "PBS's Mr. Rogers in foreground. Dirk is hiding behind him, peeking out from behind his left shoulder.",
                width = 1_200,
                height = 1_818,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 4, 18))
            SessionDayHeader(dayId = "shimmer-25", dateString = "Shimmer 25", cardImageSrc = "flags/Mun.svg")
            Log_2026_04_18_Day_1()
            SessionDayHeader(dayId = "shimmer-26", dateString = "Shimmer 26")
            Log_2026_04_18_Day_2()
            SessionDayHeader(dayId = "shimmer-27", dateString = "Shimmer 27")
            Log_2026_04_18_Day_3()
            SessionDayHeader(dayId = "shimmer-29", dateString = "Shimmer 29")
            Log_2026_04_18_Day_4()
            SessionMediaItem(
                image = "images/darkElvesFromTheMun.webp",
                linkImage = "images/darkElvesFromTheMun.webp",
                description = "A detailed hand-drawn illustration of two dark elves standing before a large moon. Tressa (left) is drawn as a paladin reminiscent of Princess Leia (although we later learned she was a Barbarian) and Delia (right) is drawn as Leeloo Dallas (a character from the movie The Fifth Element).",
                width = 1_600,
                height = 1_329,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 5, 2))
            SessionDayHeader(dayId = "shimmer-29", dateString = "Shimmer 29")
            Log_2026_05_02_Day_1()
            SessionDayHeader(dayId = "shimmer-30", dateString = "Shimmer 30")
            Log_2026_05_02_Day_2()
            SessionDayHeader(dayId = "shimmer-31", dateString = "Shimmer 31")
            Log_2026_05_02_Day_3()
            SessionMediaItem(
                image = "images/spiritTrollsJustPlane.webp",
                linkImage = "images/spiritTrollsJustPlane.webp",
                description = "A hand-drawn illustration of two '90s troll dolls flying a 'Spirit' biplane with a fairy trash talking them. This is a reference to Spirit Airlines, a failed company, and the troll dolls are meant to represent Spirit Trolls.",
                width = 2_564,
                height = 1_630,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 5, 9))
            SessionDayHeader(dayId = "shimmer-31", dateString = "Shimmer 31")
            Log_2026_05_09_Day_1()
            SessionMediaItem(
                image = "images/eyeCamera.webp",
                linkImage = "images/eyeCamera.webp",
                description = "A hand-drawn illustration of a surveillance camera with a large bloodshot eye instead of a lens, mounted on a stone wall.",
                width = 1_200,
                height = 725,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 5, 23))
            SessionDayHeader(dayId = "shimmer-31", dateString = "Shimmer 31", cardImageSrc = "images/TheFiveTabaxiBrothers_Details.webp", width = 1_200, height = 630)
            Log_2026_05_23_Day_1()
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 5, 30))
            SessionDayHeader(dayId = "shimmer-31", dateString = "Shimmer 31", cardImageSrc = "images/razorwrath.webp", width = 1_200, height = 285)
            Log_2026_05_30_Day_1()
            SessionDayHeader(dayId = "shimmer-32", dateString = "Shimmer 32")
            Log_2026_05_30_Day_2()
            SessionMediaItem(
                image = "images/AnnetteLaughingCaperDino_details.webp",
                linkImage = "images/AnnetteLaughingCaperDino_details.webp",
                width = 2_016,
                height = 1_293,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 6, 6))
            SessionDayHeader(dayId = "shimmer-32", dateString = "Shimmer 32")
            Log_2026_06_06_Day_1()
            SessionMediaItem(
                image = "images/robberD20.webp",
                linkImage = "images/robberD20.webp",
                width = 916,
                height = 634,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 8, 1))
            SessionDayHeader(dayId = "shimmer-32", dateString = "Shimmer 32")
            Log_2026_08_01_Day_1()
            SessionDayHeader(dayId = "shimmer-33", dateString = "Shimmer 33")
            Log_2026_08_01_Day_2()
            SessionMediaItem(
                image = "images/pathToPentish.webp",
                linkImage = "images/pathToPentish.webp",
                width = 1_752,
                height = 3_216,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 8, 8))
            SessionDayHeader(dayId = "shimmer-33", dateString = "Shimmer 33", cardImageSrc = "images/inanAmbush.webp", width = 4_775, height = 1_314)
            Log_2026_08_08_Day_1()
            SessionDayHeader(dayId = "shimmer-34", dateString = "Shimmer 34")
            Log_2026_08_08_Day_2()
            SessionMediaItem(
                image = "images/goramSantaHatMan.webp",
                linkImage = "images/goramSantaHatMan.webp",
                width = 1_200,
                height = 1_739,
            )
            SessionMediaItem(
                image = "images/goramSantaHatBag.webp",
                linkImage = "images/goramSantaHatBag.webp",
                width = 1_200,
                height = 1_841,
            )
            SessionMediaItem(
                image = "images/goramSantaHatPlant.webp",
                linkImage = "images/goramSantaHatPlant.webp",
                width = 1_200,
                height = 1_820,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 8, 29))
            SessionDayHeader(dayId = "shimmer-34", dateString = "Shimmer 34")
            Log_2026_08_29_Day_1()
            SessionDayHeader(dayId = "shimmer-35", dateString = "Shimmer 35")
            Log_2026_08_29_Day_2()
            SessionDayHeader(dayId = "shimmer-36", dateString = "Shimmer 36", cardImageSrc = "images/bearforce.webp", width = 1_200, height = 1_077)
            Log_2026_08_29_Day_3()
            SessionDayHeader(dayId = "shimmer-37", dateString = "Shimmer 37")
            Log_2026_08_29_Day_4()
            SessionMediaItem(
                image = "images/roc.webp",
                linkImage = "images/roc.webp",
                width = 1_200,
                height = 752,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 9, 12))
            SessionDayHeader(dayId = "shimmer-37", dateString = "Shimmer 37")
            Log_2026_09_12_Day_1()
            SessionDayHeader(dayId = "shimmer-38", dateString = "Shimmer 38")
            Log_2026_09_12_Day_2()
            SessionDayHeader(dayId = "shimmer-39", dateString = "Shimmer 39")
            Log_2026_09_12_Day_3()
            SessionDayHeader(dayId = "shimmer-42", dateString = "Shimmer 42", cardImageSrc = "images/freeburgAndLadikor.svg")
            Log_2026_09_12_Day_4()
            SessionMediaItem(
                image = "images/bigglesworthCrazyEyes.webp",
                linkImage = "images/bigglesworthCrazyEyes.webp",
                width = 1_200,
                height = 1_489,
            )
            org.jetbrains.compose.web.dom.Hr()
            LocalizedSessionDate(LocalDate(2_026, 10, 10))
            SessionDayHeader(dayId = "shimmer-43", dateString = "Shimmer 43")
            Log_2026_10_10_Day_1()
            SessionDayHeader(dayId = "shimmer-44", dateString = "Shimmer 44")
            Log_2026_10_10_Day_2()
            SessionMediaItem(
                image = "images/ladikorNewRoute.webp",
                linkImage = "images/ladikorNewRoute.webp",
                width = 2_132,
                height = 2_518,
            )
        }
    }
}
